import { Telemetry } from '@just-in-types';
import { Reducer } from 'redux';
import {
  GET_APP_INFO,
  GET_APP_INFO_SUBSCRIPTION,
  GET_CREDENTIALS,
  GET_TABLET_PROPS,
  IKioskCredentials,
} from '../actions';

export interface ITelemetryState {
  appInfo: Telemetry.AppInfo;
  credentials: null | IKioskCredentials;
  error: any;
  newVersionAvailable: boolean;
  tabletProps: null | {
    alwaysReload?: boolean;
  };
  unsubscribeAppInfo: null | (() => void);
}
const telemetryInitialState: ITelemetryState = {
  appInfo: { currentVersion: null },
  credentials: null,
  error: null,
  newVersionAvailable: false,
  tabletProps: null,
  unsubscribeAppInfo: null,
};

const telemetryReducer: Reducer = (
  state = telemetryInitialState,
  { type, payload },
): ITelemetryState => {
  switch (type) {
    case GET_APP_INFO:
      return { ...state, appInfo: payload };
    case GET_APP_INFO_SUBSCRIPTION:
      return { ...state, unsubscribeAppInfo: payload };
    case GET_CREDENTIALS:
      return { ...state, credentials: payload };
    case GET_TABLET_PROPS:
      return { ...state, tabletProps: { ...payload } };
    default:
      return state;
  }
};

export default telemetryReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/telemetryReducer.ts